import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';
import $ from 'jquery';
import {
  withContextualAttributeTemplate,
  prependAccountAttribute,
} from '@bingads-webui-campaign/recommendation-contextual-attribute';
import { CONTEXTUAL_ENTITY_TYPE } from '@bingads-webui-campaign/recommendation-core';
import SiteLinkAssociationEditor from '@bingads-webui-campaign-legacy/adextension-sitelink/view/associationsEditor';
import CalloutAssociationEditor from '@bingads-webui-campaign-legacy/adextension-callout/view/associationsEditor';
import UiBlocker from '@bingads-webui-component-legacy/uiblocker/service/uiBlocker';
import ViewModel from '../viewmodel/AdExtensionEditorModel';
import template from '../template/adextension.pug';
import strongTemplate from '../template/strong.pug';

const metricTypes = ['clicks', 'ctr', 'spend', 'cpc'];
const typeTextMapper = {
  SiteLinkOpportunity: 'sitelink',
  CalloutOpportunity: 'callout',
};

export default class AdExtensionEditorView extends Backbone.View {
  initialize({
    deps,
    data,
    type,
    opportunities = {},
    i18n,
    isMCC,
    readOnly,
  }) {
    this.deps = deps;
    this.data = data;
    this.hideTitle = !_.isNumber(data.CurrentCtr) || !_.isNumber(data.EstimatedIncreaseInCtr);
    this.type = type;
    this.opportunities = opportunities;
    this.i18n = i18n;
    this.isMCC = isMCC;
    this.viewModel = new ViewModel({
      extensionData: this.opportunities,
      i18n: this.i18n,
      readOnly,
    });
    this.siteLinkAssociationEditor = SiteLinkAssociationEditor;
    this.calloutAssociationEditor = CalloutAssociationEditor;

    const entity = withContextualAttributeTemplate({
      opportunityId: this.data.Opportunities[0].OpportunityId,
      entityName: this.data.Target.CampaignName,
      entityId: this.data.Target.CampaignId,
      entityType: CONTEXTUAL_ENTITY_TYPE.CAMPAIGN,
      status: 'false', // to check whether it is 1st time to create this view
      isExpandingView: true,
      ariaLabel: this.i18n.getString('Click to scope to campaign {{campaignName}}', { campaignName: this.data.Target.CampaignName }),
    });

    this.hintText = i18n.getString('AdExtension_Inline_View_HintText', {
      name: this.isMCC ? prependAccountAttribute({
        originEntity: entity,
        opportunityId: this.data.Opportunities[0].OpportunityId,
        accountId: this.data.Target.AccountId,
        accountName: this.data.Target.AccountName,
      }) : entity,
      count: strongTemplate({ text: '4' }),
      typeText: typeTextMapper[this.type],
    });
    this.cpcIncreaseText = i18n.getString('AdExtension_Inline_View_CPC_Increase_HintText');
    this.cpcIncreaseReason = i18n.getString('AdExtension_Inline_View_CPC_Increase_Resason', {
      typeText: typeTextMapper[this.type],
    });
  }

  getAssociationEditorAndRender() {
    UiBlocker.block(this.$el, '.ad-extension-association-editor');
    const associationEditorMapper = {
      SiteLinkOpportunity: this.siteLinkAssociationEditor,
      CalloutOpportunity: this.calloutAssociationEditor,
    };
    this.associationEditor = new associationEditorMapper[this.type]({
      campaignId: this.data.Target.CampaignId,
      campaignName: this.data.Target.CampaignName,
      entityType: 'campaign',
      hasSubTitle: false,
      showErrorsInline: true,
      showSaveBar: false,
      disableDelete: true,
      usePanel: true,
    });

    // bind actions for associationeditor & render
    if (this.associationEditor) {
      // bind actions
      this.associationEditor.on('selected-changed', (selectedChanged) => {
        this.viewModel.isApplyEnable(selectedChanged);
      });
      this.associationEditor.on('save:success', (selectedItems) => {
        this.trigger('apply', { data: { adExtensionIds: _.pluck(selectedItems, 'Id') }, Id: _.first(this.opportunities.ids) });
      });
      this.associationEditor.on('open:extensionEditor', () => {
        this.trigger('popup:editor');
        $('.k-window').addClass('k-window-over-blocker');
      });
      this.associationEditor.on('close:extensionEditor', () => {
        this.trigger('remove:editor');
      });

      // render
      this.associationEditor.render();
      this.$('.ad-extension-association-editor').append(this.associationEditor.$el);
    }
    UiBlocker.unblock(this.$el, '.ad-extension-association-editor');
  }

  apply(e) {
    this.associationEditor.trigger('associate:extensions', e);
  }

  render() {
    this.$el.html(template(_.extend({
      i18n: this.i18n,
      hintText: this.hintText,
      cpcIncreaseText: this.cpcIncreaseText,
      cpcIncreaseReason: this.cpcIncreaseReason,
      hideTitle: this.hideTitle,
      metricTypes,
      metricTypeDescriptions: {
        clicks: this.i18n.getString('Details_View_Est_Clicks'),
        ctr: this.i18n.getString('Details_View_Est_CTR'),
        spend: this.i18n.getString('Details_View_Est_Cost'),
        cpc: this.i18n.getString('Details_View_Est_CPC'),
      },
    })));

    ko.applyBindings(this.viewModel, this.el);
    this.getAssociationEditorAndRender();

    return this;
  }
}
